import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-message-custom',
  templateUrl: './message-custom.component.html',
  styleUrls: ['./message-custom.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageCustomComponent {}
